var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "edit-form__item" },
    [
      _vm.items.length <= 0 ? _c("div", [_vm._v("-")]) : _vm._e(),
      _vm._l(_vm.items, function (item, index) {
        return _c("div", [
          _c("div", { staticClass: "wc-label bold" }, [
            item.type == "ADMIN"
              ? _c("b", [_vm._v("推播回覆 ")])
              : _c("b", [_vm._v("客戶回報 ")]),
            _c("span", { staticClass: "wc-time" }, [
              _vm._v(_vm._s(item.created_at)),
            ]),
            _vm._v("： "),
            _c("div", { staticClass: "css-fix" }, [
              _vm._v(_vm._s(item.question)),
            ]),
            _c("b", [_vm._v("備註:")]),
            _c("div", { staticClass: "css-fix" }, [
              _vm._v(_vm._s(item.remark)),
            ]),
            _c("hr"),
          ]),
        ])
      }),
      _vm._m(0),
      _c("wc-textarea", {
        staticClass: "wc-textarea",
        attrs: {
          required: "",
          rows: "2",
          name: "question",
          model: "question",
          value: _vm.question,
          disabled:
            _vm.question_status == "DONE" || _vm.question_status == "IMPROVE",
        },
        on: { change: _vm.getQuestion },
      }),
      _c("div", { staticStyle: { "margin-top": "10px" } }, [_vm._v("備註")]),
      _c("wc-textarea", {
        staticClass: "wc-textarea",
        attrs: {
          rows: "3",
          name: "remark",
          model: "remark",
          value: _vm.remark,
          disabled:
            _vm.question_status == "DONE" || _vm.question_status == "IMPROVE",
        },
        on: { change: _vm.getRemark },
      }),
      _c(
        "wc-button",
        {
          staticClass: "btn btn-danger",
          attrs: {
            disabled:
              _vm.question_status == "DONE" || _vm.question_status == "IMPROVE",
          },
          on: { click: _vm.onClick },
        },
        [_vm._v(" 立即推播回覆 ")]
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-top": "20px" } }, [
      _vm._v("推播回覆 "),
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }